type ILogoIconProps = {
	size?: number
	imgSize?: number
	stroke?: 'none' | 'currentColor' | 'black'
	fill?: 'none' | 'currentColor' | 'black' | 'white'
}

export const LogoIcon = (props: ILogoIconProps) => {
	const { size=22, imgSize=22, stroke="currentColor", fill="currentColor" } = props
	const k: number = 32.0 / 22.0
	return (
		<svg
			width={`${size}px`}
			height={`${k * size}px`}
			viewBox={`0 0 ${imgSize} ${k * imgSize}`}
			stroke={stroke}
			fill={fill}
			strokeWidth="0"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path fillRule="evenodd" clipRule="evenodd" d="M17.5483 1.9218H19.528C19.9512 1.91719 20.3105 2.27493 20.3044 2.70177C20.3044 2.85682 20.2632 2.99809 20.1806 3.12397C20.0995 3.24833 19.9912 3.34352 19.8566 3.40649L20.3044 3.9853H19.4515L19.0648 3.48171H18.3495V3.9853H17.5483V1.9218ZM19.3261 2.5252H18.3495V2.87678H19.3261C19.3751 2.87678 19.4163 2.8599 19.4498 2.82612C19.4851 2.7908 19.502 2.74935 19.502 2.70177C19.502 2.6035 19.4239 2.5252 19.3261 2.5252Z" />
			<path fillRule="evenodd" clipRule="evenodd" d="M21.8417 2.95603C21.8417 4.57633 20.534 5.88985 18.9207 5.88985C17.3077 5.88985 16 4.57633 16 2.95603C16 1.33573 17.3077 0.0222168 18.9207 0.0222168C20.534 0.0222168 21.8417 1.33573 21.8417 2.95603ZM21.3116 2.95603C21.3116 4.2823 20.2412 5.35746 18.9207 5.35746C17.6003 5.35746 16.5298 4.2823 16.5298 2.95603C16.5298 1.62977 17.6003 0.554619 18.9207 0.554619C20.2412 0.554619 21.3116 1.62977 21.3116 2.95603Z" />
			<path d="M1.92969 15.789L11.0466 0.072998L19.9786 15.789H15.0506L11.0466 8.85909L7.04254 15.789H1.92969Z" />
			<path d="M0 17.614L5.63308 27.1665L6.57852 23.9591L10.9208 31.9777L15.1992 23.9591L16.276 27.1665L21.8416 17.614H0Z" />
		</svg>
// 		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
// 		     width={`${width ?? '36px'}`}
// 		     height={`${height ?? '45px'}`}
// 		     viewBox="0 0 2438.000000 3026.000000"
// 		     preserveAspectRatio="xMidYMid meet">

// 			<g transform="translate(0.000000,3026.000000) scale(0.100000,-0.100000)"
// 			   fill="#000000" stroke="none">
// 				<path d="M12190 15135 l0 -15130 1515 1515 1515 1515 0 1247 c0 687 -3 1248
// -7 1248 -5 0 -286 -278 -625 -617 l-618 -618 0 12095 0 12095 -890 890 -890
// 890 0 -15130z"/>
// 				<path d="M9608 27673 l-888 -888 0 -11655 0 -11655 1515 -1515 1515 -1515 0
// 1255 0 1255 -625 625 -625 625 -2 12177 -3 12178 -887 -887z"/>
// 				<path d="M15660 15135 l0 -11660 890 890 890 890 0 9880 0 9880 -890 890 -890
// 890 0 -11660z"/>
// 				<path d="M3517 21602 l-3507 -3507 0 -1270 0 -1270 2620 2620 2620 2620 0
// -5665 0 -5665 -840 840 -840 840 0 1460 0 1460 620 620 620 620 0 1265 0 1265
// -1515 -1515 -1515 -1515 0 -2195 0 -2195 2630 -2630 2630 -2630 0 9978 c0
// 5487 -3 9977 -8 9977 -4 0 -1585 -1578 -3515 -3508z"/>
// 				<path d="M19130 15135 l0 -8190 890 890 890 890 2 3467 3 3466 829 -2581 c457
// -1420 835 -2601 841 -2624 l11 -42 892 892 892 892 0 2940 0 2940 -888 888
// c-488 488 -890 887 -894 887 -5 0 -9 -798 -10 -1772 l-3 -1772 -838 2619 -838
// 2620 -889 890 -890 890 0 -8190z"/>
// 			</g>
// 		</svg>
	)
}